package net.frozenbit.games.soundgame.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.theme.Colors
import net.frozenbit.games.soundgame.theme.Dimensions
import net.frozenbit.games.soundgame.theme.Shapes
import net.frozenbit.games.soundgame.theme.Typography

@Composable
fun Prompt(
    text: String,
    modifier: Modifier = Modifier,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .widthIn(max = 800.dp)
            .background(
                color = Colors.Host.containerBackground,
                shape = Shapes.Host.mediumContainer,
            )
            .padding(Dimensions.Host.smallInnerPadding)
    ) {
        Text(
            text = "„",
            color = Colors.Host.containerForegroundMuted,
            fontSize = Typography.Host.titleSize,
            modifier = Modifier.align(Alignment.BottomStart)
        )
        Text(
            text = text,
            color = Colors.Host.containerForeground,
            style = Typography.Host.body,
            modifier = Modifier
                .padding(
                    horizontal = Dimensions.Host.bigInnerPadding,
                    vertical = Dimensions.Host.mediumInnerPadding,
                )
                .align(Alignment.Center)
        )
        Text(
            text = "“",
            color = Colors.Host.containerForegroundMuted,
            fontSize = Typography.Host.titleSize,
            modifier = Modifier.align(Alignment.TopEnd)
        )
    }
}